export const categories = [
  {
    key: "star",
    name: "明星动态",
    description:
      "追踪艺人的最新行程、影视作品与舞台动态，第一时间掌握娱乐圈风向，看看你关注的那颗星最近在忙什么。",
    cover:
      "https://readdy.ai/api/search-image?query=Glamorous%20stage%20with%20warm%20spotlights%20and%20a%20golden%20microphone%20in%20the%20center%2C%20elegant%20red%20curtain%20backdrop%2C%20cinematic%20warm%20orange%20tones%2C%20minimal%20editorial%20composition%2C%20soft%20glow%2C%20high%20detail%2C%20magazine%20cover%20style&width=1200&height=600&seq=cat-star-01&orientation=landscape",
  },
  {
    key: "hot",
    name: "热点新闻",
    description:
      "梳理全网关注的热点事件来龙去脉，用清晰的时间线帮你快速读懂正在发生的大事。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20news%20concept%20with%20floating%20newspaper%20pages%20and%20warm%20orange%20light%20streaks%20on%20a%20clean%20cream%20background%2C%20minimal%20editorial%20illustration%2C%20dynamic%20composition%2C%20soft%20shadows%2C%20high%20detail%2C%20magazine%20style&width=1200&height=600&seq=cat-hot-01&orientation=landscape",
  },
  {
    key: "buzz",
    name: "网络热议",
    description:
      "盘点社交平台上刷屏的话题与人气梗，看看大家都在聊什么，别再错过下一波热梗。",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20speech%20bubbles%20and%20chat%20icons%20floating%20on%20a%20warm%20cream%20background%20with%20orange%20accents%2C%20playful%20minimal%20illustration%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20magazine%20cover%20style&width=1200&height=600&seq=cat-buzz-01&orientation=landscape",
  },
  {
    key: "society",
    name: "社会资讯",
    description:
      "关注贴近生活的社会民生资讯，从社区食堂到城市绿道，发现身边悄然发生的小变化。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20illustration%20of%20a%20modern%20city%20community%20with%20green%20trees%20and%20small%20shops%20on%20a%20cream%20background%2C%20orange%20sunlight%20accents%2C%20minimal%20flat%20style%2C%20soft%20shadows%2C%20high%20detail%2C%20magazine%20style&width=1200&height=600&seq=cat-society-01&orientation=landscape",
  },
];

export const articles = [
  {
    id: "s1",
    title: "林语晨新剧正式开机，片场路透照曝光引发观众期待",
    subtitle: "传闻中的都市题材终于官宣，主演阵容成讨论焦点",
    summary:
      "备受关注的都市剧《晚风信笺》今日正式开机，主演林语晨现身片场的路透照在社交平台快速传播，不少观众表示对剧中的职场故事充满期待。",
    category: "star",
    author: "娱乐观察组",
    publishedAt: "2026-10-15T09:20:00+08:00",
    views: 48210,
    tags: ["明星动态", "新剧", "林语晨"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Film%20set%20with%20a%20director%20chair%20and%20camera%20under%20warm%20golden%20light%2C%20blurred%20studio%20background%20in%20soft%20orange%20tones%2C%20cinematic%20mood%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=art-star-01&orientation=landscape",
    content:
      "备受关注的都市题材剧《晚风信笺》正式官宣开机，剧组今日释出首组片场工作照，画面中主演林语晨身穿简洁的职业造型，与导演在监视器前交流剧本，氛围十分投入。\n\n据剧组介绍，本剧围绕一家传统出版社的转型故事展开，讲述几位年轻编辑在行业变化中寻找自我价值的过程。林语晨在剧中饰演一位坚持内容理想的编辑，角色性格细腻而坚韧。\n\n路透照曝光后迅速登上社交平台热榜，不少观众留言表示，很期待看到职场题材中更真实、更有温度的成长故事。也有粉丝注意到片场的道具细节，纷纷猜测剧中的时间背景。\n\n剧组方面表示，目前拍摄刚刚起步，后续将陆续公布更多角色信息与幕后花絮，预计明年与观众见面。",
  },
  {
    id: "s2",
    title: "苏泽宇时隔三年回归舞台，新一轮巡回演唱会正式官宣",
    subtitle: "首批城市名单公布，开票时间成为粉丝最关心的问题",
    summary:
      "歌手苏泽宇在社交平台发布一段舞台剪影视频，正式宣布启动新一轮巡回演唱会，首批城市名单同步公开，引发粉丝热烈讨论。",
    category: "star",
    author: "现场速递",
    publishedAt: "2026-10-14T20:05:00+08:00",
    views: 62380,
    tags: ["明星动态", "演唱会", "舞台"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Concert%20stage%20with%20warm%20amber%20spotlights%20and%20light%20beams%20cutting%20through%20haze%2C%20silhouette%20of%20a%20microphone%20stand%2C%20cinematic%20orange%20tone%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=art-star-02&orientation=landscape",
    content:
      "歌手苏泽宇今日在社交平台发布了一段舞台剪影短片，配文简短却信息量十足，正式宣布时隔三年重启个人巡回演唱会。视频中灯光随节奏明暗交替，暗示本次演出将在舞台呈现上有更大突破。\n\n随后官方账号公布了首批巡演城市名单，覆盖南北多个城市，并透露本次演出将采用全新的乐队编制与视觉设计。消息发布后，相关话题迅速登上热搜榜前列。\n\n粉丝最为关心的开票时间目前尚未公布，主办方表示将于近期通过官方渠道统一说明，并提醒观众通过正规平台购票，谨防各类非官方渠道的溢价票务信息。\n\n业内人士分析，近年来现场演出市场持续回暖，观众对高品质舞台内容的需求明显上升，歌手们也更愿意在演唱会中投入更多创意。",
  },
  {
    id: "s3",
    title: "沈知夏深夜探店被拍，工作室回应仅为本月新戏体验生活",
    subtitle: "一组生活感十足的照片让讨论热度居高不下",
    summary:
      "演员沈知夏被拍到深夜现身一家独立咖啡馆，休闲装扮的生活照在网络流传，其工作室随后回应，此行是为新角色进行实地体验。",
    category: "star",
    author: "街拍频道",
    publishedAt: "2026-10-13T22:40:00+08:00",
    views: 31570,
    tags: ["明星动态", "街拍", "沈知夏"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Cozy%20independent%20coffee%20shop%20window%20at%20night%20with%20warm%20hanging%20lights%2C%20soft%20orange%20glow%2C%20blurred%20city%20street%20reflection%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=art-star-03&orientation=landscape",
    content:
      "演员沈知夏近日被拍到深夜现身一家街边独立咖啡馆，身穿宽松卫衣与休闲长裤，整体造型十分生活化。相关照片在网络流传后，很快引发了关于她近况的讨论。\n\n针对网络上的种种猜测，沈知夏工作室随后作出回应，表示演员近期正在为新戏中的角色做准备，走访不同类型的店铺是为了更贴近人物状态，并非外界所传的其他原因。\n\n有影迷表示理解演员为角色体验生活的做法，认为这种认真态度值得肯定。也有网友注意到，这家咖啡馆主打手冲咖啡与旧书交换，颇具文艺气息。\n\n目前该剧尚未公布更多细节，剧组表示会在合适的时机与观众分享进展。",
  },
  {
    id: "s4",
    title: "江牧野跨界执导短片，首次公开幕后创作花絮",
    subtitle: "从演员到导演的身份转换，他坦言压力不小",
    summary:
      "演员江牧野首次尝试执导短片，作品花絮今日公开。他在访谈中分享了创作过程中的挑战，以及如何用镜头讲述一个关于告别的故事。",
    category: "star",
    author: "幕后记录",
    publishedAt: "2026-10-12T16:10:00+08:00",
    views: 27840,
    tags: ["明星动态", "短片", "导演"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20set%20with%20a%20monitor%20showing%20warm%20orange%20footage%20and%20clapperboard%2C%20soft%20studio%20lighting%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=art-star-04&orientation=landscape",
    content:
      "演员江牧野首次以导演身份带来的短片作品今日释出幕后花絮。这支短片以一位老放映员的日常为主线，讲述了一个关于告别与记忆的温柔故事。\n\n谈及这次身份转换，江牧野坦言压力不小。他表示，作为演员时更多关注的是自己的表演，而作为导演则要同时在脑海里装下画面、节奏和所有人的状态，是一次全新的学习。\n\n花絮中可以看到，他在片场反复与摄影指导沟通光线，也会在每一条拍摄结束后认真回看监视器。剧组工作人员透露，为了一个十秒的镜头，团队曾反复拍摄了二十余条。\n\n据悉，该短片将参与线上短片展映活动，主创团队希望通过这次尝试，与更多观众交流对影像的理解。",
  },
  {
    id: "s5",
    title: "顾清欢新专辑概念海报释出，主打歌名暗藏巧思",
    subtitle: "极简视觉风格引发歌迷对曲风的多种猜测",
    summary:
      "歌手顾清欢发布新专辑首张概念海报，简约的画面与含蓄的文案立刻引起歌迷讨论，许多人开始猜测这张专辑的整体音乐走向。",
    category: "star",
    author: "音乐现场",
    publishedAt: "2026-10-11T11:30:00+08:00",
    views: 22960,
    tags: ["明星动态", "新专辑", "顾清欢"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Minimal%20album%20concept%20poster%20with%20a%20single%20vinyl%20record%20on%20a%20warm%20cream%20surface%2C%20soft%20orange%20side%20light%2C%20abstract%20shapes%2C%20editorial%20design%2C%20high%20detail&width=800&height=600&seq=art-star-05&orientation=landscape",
    content:
      "歌手顾清欢今日发布新专辑的首张概念海报，画面以极简的线条与单一暖色块构成，配文只有短短几个字，却让歌迷浮想联翩。海报释出不到半天，相关话题便进入社交平台热榜。\n\n有歌迷指出，海报中出现的几何符号与新专辑的主打歌名存在某种呼应，猜测本张专辑可能会延续她一贯的细腻叙事风格，同时在编曲上加入更多实验元素。\n\n唱片公司方面回应称，新专辑从筹备到完成历时近两年，顾清欢本人参与了大量词曲创作，希望用一整张作品记录这段时间的思考与变化。\n\n目前专辑的正式发行时间尚未公布，官方表示将于近期陆续放出发行预告与试听片段。",
  },
  {
    id: "h1",
    title: "年度网络流行语榜单出炉，这些热词你今年用过几个",
    subtitle: "榜单从数亿条社交文本中筛选而来，覆盖生活的方方面面",
    summary:
      "一份基于社交平台文本分析的年度网络流行语榜单今日公布，多个来源于日常生活的表达成功入选，成为今年网络语言的生动写照。",
    category: "hot",
    author: "热点追踪",
    publishedAt: "2026-10-15T08:00:00+08:00",
    views: 75420,
    tags: ["热点新闻", "网络流行语", "榜单"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Smartphone%20screen%20mockup%20with%20floating%20chat%20bubbles%20and%20warm%20orange%20glow%20on%20a%20clean%20cream%20background%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=art-hot-01&orientation=landscape",
    content:
      "一份基于社交平台文本分析的年度网络流行语榜单今日正式公布。榜单团队表示，他们从数亿条公开社交文本中筛选出高频表达，再结合传播速度与使用场景进行综合评估。\n\n入选的表达大多来自日常生活，有的源于一次网络直播中的口头禅，有的则诞生于某段被反复转发的短视频。榜单负责人指出，网络语言的更替速度越来越快，一个词从流行到退潮可能只需要几周。\n\n有趣的是，今年不少热词都带有明显的“情绪调节”色彩，人们倾向于用轻松、自嘲的方式表达压力与期待，这也反映出当下网络交流的一种普遍心态。\n\n专家提醒，网络流行语丰富了日常表达，但在正式场合仍应注意使用场景，避免造成沟通上的误解。",
  },
  {
    id: "h2",
    title: "城市夜市经济持续回暖，年轻摊主带来不少新玩法",
    subtitle: "从手作体验到移动咖啡车，夜市正在被重新定义",
    summary:
      "入秋以来，多个城市的夜市人气明显回升。与以往不同，越来越多年轻摊主把创意体验带入夜市，让这里成为新的社交与休闲去处。",
    category: "hot",
    author: "城市观察",
    publishedAt: "2026-10-14T18:30:00+08:00",
    views: 51360,
    tags: ["热点新闻", "夜市", "城市生活"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Bustling%20night%20market%20street%20with%20warm%20string%20lights%20and%20small%20stalls%2C%20soft%20orange%20glow%2C%20blurred%20crowd%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=art-hot-02&orientation=landscape",
    content:
      "入秋以来，多个城市的夜市人气明显回升。傍晚时分，街边的摊位陆续亮起暖色灯串，人流在摊位之间缓慢流动，构成一幅热闹的都市夜景。\n\n与以往以小吃为主的夜市不同，如今越来越多年轻摊主把创意体验带入其中。有人支起移动咖啡车，有人提供现场手作体验，还有摊主把旧唱片与二手书摆上摊位，吸引了不少驻足。\n\n一位经营手作摊位的摊主表示，自己白天有正式工作，晚上出摊更多是出于兴趣，希望认识更多志同道合的朋友。这样的想法在年轻摊主中颇具代表性。\n\n城市管理部门表示，将在规范经营与保障安全的前提下，为夜市经济提供更灵活的场地支持，让这份烟火气延续下去。",
  },
  {
    id: "h3",
    title: "冬季旅游目的地搜索量攀升，小众城市意外走红",
    subtitle: "人们开始偏爱节奏更慢、人更少的旅行方式",
    summary:
      "随着天气转凉，冬季旅游的搜索热度持续上升。与往年相比，一些过去较少被提及的小众城市在今年冬天意外受到关注。",
    category: "hot",
    author: "旅行频道",
    publishedAt: "2026-10-13T14:15:00+08:00",
    views: 39870,
    tags: ["热点新闻", "旅游", "冬季"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Quiet%20mountain%20town%20in%20winter%20with%20misty%20hills%20and%20warm%20lit%20windows%2C%20soft%20orange%20sunset%20light%2C%20minimal%20editorial%20landscape%20photography%2C%20high%20detail&width=800&height=600&seq=art-hot-03&orientation=landscape",
    content:
      "随着天气逐渐转凉，冬季旅游的搜索热度持续上升。多家旅行平台的数据显示，今年冬天的出行预订高峰比往年来得更早一些。\n\n与往年不同的是，一些过去较少被提及的小众城市在今年意外走红。安静的山间小镇、可以慢慢逛的旧街区、以及适合发呆的湖边咖啡馆，成为不少旅行者关注的关键词。\n\n有旅行爱好者表示，自己现在更偏爱节奏慢一些的旅行方式，与其在热门景点排队打卡，不如找个小城住上几天，逛逛当地的市集，和店主聊聊天。\n\n业内人士分析，随着出行方式更加多样化，人们对于旅行的期待也正在从“看风景”转向“过生活”，这或许是小众目的地升温的重要原因。",
  },
  {
    id: "h4",
    title: "人工智能走进日常生活，普通人如何跟上这股节奏",
    subtitle: "从工作助手到生活助理，变化正在悄悄发生",
    summary:
      "人工智能应用正在加速融入日常工作与生活。面对不断涌现的新工具，越来越多人开始思考：普通人该如何从容跟上这股节奏？",
    category: "hot",
    author: "科技观察",
    publishedAt: "2026-10-12T10:00:00+08:00",
    views: 44120,
    tags: ["热点新闻", "科技", "效率工具"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Abstract%20artificial%20intelligence%20concept%20with%20glowing%20nodes%20and%20warm%20orange%20light%20paths%20on%20a%20clean%20cream%20background%2C%20minimal%20editorial%20illustration%2C%20high%20detail&width=800&height=600&seq=art-hot-04&orientation=landscape",
    content:
      "人工智能应用正在加速融入日常工作与生活。整理会议记录、草拟邮件、分析表格数据……越来越多的琐碎任务，如今都能借助工具更快完成。\n\n面对不断涌现的新工具，有人跃跃欲试，也有人感到焦虑。某互联网公司的产品经理表示，与其担心被替代，不如把它当成一位随时在线的助手，把重复劳动交给工具，把精力留给真正需要判断力的部分。\n\n多位从业者建议，普通人不必追求掌握所有新技术，可以从自己的工作场景出发，先挑一两个高频、重复的任务尝试使用，逐步建立起对工具的理解和判断。\n\n也有专家提醒，使用相关工具时要注意保护个人与工作信息，避免将敏感数据随意上传至第三方平台。",
  },
  {
    id: "h5",
    title: "老牌综艺宣布重启引发回忆杀，观众期待值拉满",
    subtitle: "经典环节将保留，同时加入更多贴近当下的新设计",
    summary:
      "一档陪伴观众多年的老牌综艺今日宣布重启，官方发布的预告片勾起不少人的回忆，相关内容迅速在社交平台传播。",
    category: "hot",
    author: "综艺前线",
    publishedAt: "2026-10-11T19:45:00+08:00",
    views: 36540,
    tags: ["热点新闻", "综艺", "回忆杀"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Retro%20television%20set%20with%20warm%20glow%20and%20vintage%20color%20bars%20on%20a%20cream%20background%2C%20soft%20orange%20lighting%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=art-hot-05&orientation=landscape",
    content:
      "一档陪伴观众多年的老牌综艺今日正式宣布重启。官方发布的先导预告片中，熟悉的开场音乐与经典环节的剪影依次出现，瞬间勾起不少人的回忆。\n\n节目组表示，重启版本将保留观众最熟悉的几个核心环节，同时加入更多贴近当下生活的全新设计，并邀请不同领域的嘉宾参与，希望既有情怀又不失新鲜感。\n\n预告发布后，相关话题迅速在社交平台传播，不少网友留言回忆起当年和家人一起守着电视的时光，也有人好奇新一季会有哪些新面孔加入。\n\n据悉，节目将于近期开始录制，官方表示会陆续公布嘉宾阵容与播出时间。",
  },
  {
    id: "b1",
    title: "社交平台新表情包刷屏，网友直呼根本停不下来",
    subtitle: "一组会动的可爱形象成为近期聊天窗口的常客",
    summary:
      "一组新上线的表情包近日在社交平台刷屏，凭借软萌的形象和恰到好处的表达力，成为不少人日常聊天的新宠。",
    category: "buzz",
    author: "网络热榜",
    publishedAt: "2026-10-15T13:10:00+08:00",
    views: 58230,
    tags: ["网络热议", "表情包", "社交"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Playful%20colorful%20chat%20emoji%20stickers%20floating%20over%20a%20warm%20cream%20background%20with%20orange%20accents%2C%20minimal%20illustration%2C%20soft%20shadows%2C%20high%20detail&width=800&height=600&seq=art-buzz-01&orientation=landscape",
    content:
      "一组新上线的表情包近日在社交平台刷屏。凭借软萌的形象和恰到好处的表达力，它迅速成为不少人日常聊天窗口里的常客。\n\n不少网友表示，这组表情包最打动人的地方在于“情绪精准”，无论是礼貌拒绝还是温柔吐槽，都能找到一个刚刚好的画面，让对话的氛围轻松不少。\n\n表情包的创作者在社交平台分享道，灵感来自生活里一些微小却真实的瞬间，希望用轻松的方式记录普通人的日常情绪。\n\n目前该系列仍在持续更新，创作者透露后续还会根据网友的反馈加入更多场景，让表达变得更丰富。",
  },
  {
    id: "b2",
    title: "明星同款穿搭被网友扒出，平平无奇的单品意外卖断货",
    subtitle: "一件基础款外套成为近期最热门的讨论对象",
    summary:
      "某位艺人近期出席活动时的穿搭被网友细心扒出，其中一件看似普通的基础款外套意外走红，相关商品很快便显示缺货。",
    category: "buzz",
    author: "穿搭研究所",
    publishedAt: "2026-10-14T15:25:00+08:00",
    views: 47690,
    tags: ["网络热议", "穿搭", "同款"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Neat%20flatlay%20of%20a%20minimal%20beige%20jacket%20with%20small%20accessories%20on%20a%20cream%20surface%2C%20warm%20orange%20side%20light%2C%20editorial%20fashion%20photography%2C%20high%20detail&width=800&height=600&seq=art-buzz-02&orientation=landscape",
    content:
      "某位艺人近期出席活动时的一套穿搭被网友细心扒出，其中一件看似普通的基础款外套意外成为讨论焦点。\n\n有网友表示，这件外套之所以受欢迎，正是因为它的“低存在感”——颜色百搭、版型利落，普通人日常穿着也不违和。相关商品很快在多个平台显示缺货。\n\n穿搭博主则提醒，同款单品虽然好看，但更重要的是结合自身的身形与场合来选择，与其盲目追同款，不如学习其中的搭配思路，比如用基础色打底、再点缀一件有质感的单品。\n\n也有消费者表示，看到喜欢的单品会先收藏观察，等热度过去再理性判断是否真的需要，避免一时冲动消费。",
  },
  {
    id: "b3",
    title: "电子榨菜成打工人新宠，下饭视频为何这么上头",
    subtitle: "一边吃饭一边看点什么，成了很多人的日常仪式",
    summary:
      "所谓“电子榨菜”，指的是吃饭时用来下饭的视频或音频内容。这个说法近期频繁被提及，折射出当代人独特的用餐习惯。",
    category: "buzz",
    author: "生活方式",
    publishedAt: "2026-10-13T12:00:00+08:00",
    views: 41850,
    tags: ["网络热议", "生活方式", "下饭视频"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Cozy%20desk%20with%20a%20warm%20meal%20and%20a%20small%20tablet%20playing%20a%20video%2C%20soft%20orange%20afternoon%20light%2C%20minimal%20editorial%20lifestyle%20photography%2C%20high%20detail&width=800&height=600&seq=art-buzz-03&orientation=landscape",
    content:
      "所谓“电子榨菜”，指的是吃饭时用来下饭的视频或音频内容。这个说法近期被频繁提及，折射出当代人独特的用餐习惯。\n\n不少上班族表示，一天中最放松的时刻，就是端着饭坐在桌前，打开一段熟悉的视频，让嘈杂的思绪慢慢安静下来。有人偏爱轻松的生活记录，有人则靠着反复重刷的老剧集获得安心感。\n\n心理学爱好者分析，这类内容之所以“上头”，是因为它提供了稳定的陪伴感与较低的认知负担，让人在短暂的一餐时间里得到片刻松弛。\n\n也有人提出，适度用它调节情绪无可厚非，但如果因此忽略了与身边人的交流，或许就需要稍微留意一下了。",
  },
  {
    id: "b4",
    title: "网友晒出十年对比照，话题热度持续攀升",
    subtitle: "照片背后是普通人的成长，也是时代的缩影",
    summary:
      "一个晒出“十年前与现在”对比照的话题近期在社交平台持续升温，网友们纷纷翻出旧照片，记录这些年自己的变化。",
    category: "buzz",
    author: "话题中心",
    publishedAt: "2026-10-12T21:05:00+08:00",
    views: 35260,
    tags: ["网络热议", "对比照", "回忆"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Two%20stacked%20polaroid%20photos%20on%20a%20warm%20cream%20surface%20with%20soft%20orange%20light%2C%20minimal%20editorial%20photography%2C%20nostalgic%20mood%2C%20high%20detail&width=800&height=600&seq=art-buzz-04&orientation=landscape",
    content:
      "一个晒出“十年前与现在”对比照的话题近期在社交平台持续升温。网友们纷纷翻出旧照片，与如今的自己并排展示，记录这些年的变化。\n\n照片里的变化各不相同，有人换了发型，有人搬去了另一座城市，也有人从学生变成了职场人。评论区里，更多的是彼此鼓励与温暖的问候。\n\n有网友感慨，翻看旧照时才发现，自己以为没什么变化，其实一路走来已经走了很远。这种“被时间温柔推着走”的感觉，引起了不少人的共鸣。\n\n也有人借此提醒大家，不妨定期整理一下相册，那些被随手拍下的日常，往往在多年后会变成最珍贵的记录。",
  },
  {
    id: "b5",
    title: "一句话挑战赛火出圈，各路网友花式接梗",
    subtitle: "简单规则加上无限脑洞，让参与门槛变得很低",
    summary:
      "一个只需一句话就能参与的网络挑战赛近期火出圈，凭借极低的参与门槛和充满创意的接梗方式，吸引了大量网友加入。",
    category: "buzz",
    author: "创意工坊",
    publishedAt: "2026-10-11T17:20:00+08:00",
    views: 32410,
    tags: ["网络热议", "挑战赛", "接梗"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Microphone%20on%20a%20stand%20with%20warm%20orange%20spotlight%20and%20floating%20speech%20bubbles%20on%20a%20cream%20background%2C%20minimal%20editorial%20illustration%2C%20high%20detail&width=800&height=600&seq=art-buzz-05&orientation=landscape",
    content:
      "一个只需一句话就能参与的网络挑战赛近期火出圈。规则非常简单：用一句话接住上个网友留下的梗，再把它交给下一个人。\n\n正是这种极低的参与门槛，加上几乎没有边界的脑洞空间，让大量网友加入其中。有人一本正经地制造反差，有人用生活化的细节制造笑点，评论区俨然成了一个即兴创作现场。\n\n传播学爱好者分析，这类挑战之所以能迅速扩散，是因为它把创作权交还给了普通人，每个人既能当观众，也能当作者，参与感很强。\n\n也有人提醒，接梗虽有趣，但要注意分寸，避免涉及他人隐私或引起不必要的误会，让这份轻松保持下去。",
  },
  {
    id: "soc1",
    title: "多地推行垃圾分类新规，市民参与度稳步提升",
    subtitle: "从投放点到回收流程，细节处更贴近生活",
    summary:
      "多个城市近期更新了生活垃圾分类的细则，在投放时间、分类指引等方面做出更贴合居民习惯的调整，市民参与度稳步提升。",
    category: "society",
    author: "民生观察",
    publishedAt: "2026-10-15T07:30:00+08:00",
    views: 28740,
    tags: ["社会资讯", "垃圾分类", "社区"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Colorful%20recycling%20bins%20in%20a%20clean%20modern%20community%20with%20green%20plants%2C%20soft%20morning%20light%20with%20warm%20orange%20accents%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=art-soc-01&orientation=landscape",
    content:
      "多个城市近期更新了生活垃圾分类的细则，在投放时间、分类指引等方面做出更贴合居民习惯的调整。\n\n与以往相比，新版细则更注重细节体验。例如在投放点增设了清晰的图标指引，并针对上班族调整了部分时段的开放时间，让分类投放不再是“赶时间”的负担。\n\n多个社区还组织了志愿者现场引导，通过小游戏和示范讲解，帮助居民快速掌握分类方法。有居民表示，刚开始会觉得麻烦，熟悉之后发现其实并不复杂。\n\n相关部门表示，垃圾分类是一项需要长期坚持的工作，未来还会根据居民反馈持续优化流程，让环保真正融入日常生活。",
  },
  {
    id: "soc2",
    title: "社区食堂人气火爆，平价套餐成上班族新选择",
    subtitle: "干净、实惠、离家近，成了它最实在的吸引力",
    summary:
      "一段时间以来，多个社区的便民食堂人气持续走高。价格实惠、菜品家常、环境整洁，让它成为附近上班族和老年人的日常选择。",
    category: "society",
    author: "身边事",
    publishedAt: "2026-10-14T11:50:00+08:00",
    views: 33920,
    tags: ["社会资讯", "社区食堂", "民生"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Warm%20community%20canteen%20with%20simple%20wooden%20tables%20and%20trays%20of%20home%20style%20food%2C%20soft%20orange%20lighting%2C%20clean%20minimal%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=art-soc-02&orientation=landscape",
    content:
      "一段时间以来，多个社区的便民食堂人气持续走高。每到中午，取餐窗口前便排起不太长的队伍，大家熟门熟路地点上一份家常套餐。\n\n这些食堂最大的特点是实在。价格实惠、菜量充足、环境整洁，菜品也以家常口味为主，既有适合老年人的软烂菜肴，也有年轻人喜欢的清爽小炒。\n\n一位常来就餐的上班族表示，公司附近的外卖价格越来越高，社区食堂正好解决了午饭问题，吃完还能在附近散散步，比坐在工位上点外卖放松得多。\n\n社区工作人员介绍，食堂在运营中会根据居民的意见调整菜单，也希望它不只是吃饭的地方，更能成为邻里交流和社区互动的空间。",
  },
  {
    id: "soc3",
    title: "城市绿道延长至百公里，周末骑行成新风尚",
    subtitle: "沿河的慢行系统串起了公园、市集与老街",
    summary:
      "随着多条城市绿道相继贯通，本地慢行系统总长度已延长至百公里，沿途串联起公园、市集与老街，周末骑行逐渐成为新的休闲方式。",
    category: "society",
    author: "城市漫游",
    publishedAt: "2026-10-13T09:40:00+08:00",
    views: 25680,
    tags: ["社会资讯", "绿道", "骑行"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Scenic%20riverside%20greenway%20with%20trees%20and%20a%20bicycle%20path%2C%20warm%20orange%20late%20afternoon%20light%2C%20minimal%20editorial%20landscape%20photography%2C%20high%20detail&width=800&height=600&seq=art-soc-03&orientation=landscape",
    content:
      "随着多条城市绿道相继贯通，本地慢行系统总长度已延长至百公里，沿途串联起公园、市集与老街，为市民提供了更多休闲去处。\n\n周末的绿道上，骑行者络绎不绝。有结伴出行的年轻人，也有带着孩子一起体验的家庭。沿途设置了多处休息点和饮水设施，骑行体验比过去更加友好。\n\n一位骑行爱好者分享，绿道最吸引人的地方在于“一路上都有风景”，可以随时停下看看河景，或是拐进附近的市集逛逛，节奏完全由自己掌握。\n\n相关部门表示，未来还将继续完善沿线配套设施，并加强安全管理，让绿色出行成为更多人的日常选择。",
  },
  {
    id: "soc4",
    title: "图书馆延长开放时间，夜读空间受年轻人欢迎",
    subtitle: "安静的氛围和明亮的灯光，给夜晚多了一个去处",
    summary:
      "为满足市民的阅读需求，本地多家图书馆近期延长了开放时间，并增设夜读专区，安静的阅读氛围吸引了越来越多年轻人。",
    category: "society",
    author: "文化观察",
    publishedAt: "2026-10-12T20:15:00+08:00",
    views: 21470,
    tags: ["社会资讯", "图书馆", "夜读"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Cozy%20library%20reading%20area%20at%20night%20with%20warm%20lamp%20light%20and%20tall%20bookshelves%2C%20soft%20orange%20tones%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=art-soc-04&orientation=landscape",
    content:
      "为满足市民的阅读需求，本地多家图书馆近期延长了开放时间，并增设夜读专区。傍晚之后，安静的阅览室依旧灯火通明。\n\n夜读专区在灯光与座位设计上做了专门调整，光线更柔和，座位间距也更为宽松，适合长时间阅读。不少年轻人表示，下班后在这里看一会儿书，是一天里难得的安静时刻。\n\n图书馆方面介绍，延长开放时间以来，晚间到访人数稳步增加，其中既有备考的学生，也有单纯想找个安静地方读书的上班族。\n\n工作人员还提醒，为保持阅读环境，夜读区会定期整理座位并补充书籍，希望读者共同维护这份安静与秩序。",
  },
  {
    id: "soc5",
    title: "旧物改造市集兴起，环保理念融入日常生活",
    subtitle: "旧衣、旧木料在巧手中重新焕发生机",
    summary:
      "一个以旧物改造为主题的市集近期在本地走红，摊主们用旧衣、旧木料创作出实用又别致的小物件，让环保理念变得触手可及。",
    category: "society",
    author: "创意市集",
    publishedAt: "2026-10-11T14:50:00+08:00",
    views: 19860,
    tags: ["社会资讯", "旧物改造", "环保"],
    coverImage:
      "https://readdy.ai/api/search-image?query=Upcycled%20handmade%20crafts%20from%20old%20fabric%20and%20wood%20on%20a%20warm%20cream%20table%2C%20soft%20orange%20light%2C%20minimal%20editorial%20photography%2C%20high%20detail&width=800&height=600&seq=art-soc-05&orientation=landscape",
    content:
      "一个以旧物改造为主题的市集近期在本地走红。摊位上摆满了用旧衣、旧木料和废弃容器改造的小物件，实用又别致。\n\n摊主们大多是手工爱好者，有人把旧牛仔裤改成收纳袋，有人用废木料打磨成桌面摆件。他们表示，改造的乐趣在于赋予旧物新的价值，也让环保变得更具体。\n\n不少市民带着家中闲置的衣物前来，现场学习简单的改造方法。有参与者说，以前总觉得旧东西只能丢掉，现在才发现动手改一改，反而更有意义。\n\n主办方希望，这样的市集不仅是一次创意展示，更能让“减少浪费”的理念慢慢融入日常生活的选择之中。",
  },
];